import { Empty } from 'antd';
import EmptyMessage, { OrganizationsTableTabs } from './empty-message';

export const tableLocaleSettings = (tabName: OrganizationsTableTabs) => ({
  triggerDesc: 'Сортировать по убыванию',
  triggerAsc: 'Сортировать по возрастанию',
  cancelSort: 'Отменить сортировку',
  emptyText: <Empty description={<EmptyMessage tabName={tabName} />} />,
});
